import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetch from 'whatwg-fetch'; // eslint-disable-line no-unused-vars
import API from 'lib/tessitura/API';
import features from 'lib/common/features';

const STATUSES = {
  NOT_ASKED: 'NOT_ASKED',
  VALIDATING: 'VALIDATING',
  PENDING: 'PENDING',
  REMOVING: 'REMOVING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
};

function checkRawStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    let err = new Error(response.statusText);
    err.response = response;
    throw err;
  }
}

class PromoCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      status: STATUSES.NOT_ASKED,
      activePromoCode: false,
      activated: false,
      endpoints: features.getOption('promoCode', 'endpoints')
    };

    this.addPromoCode = this.addPromoCode.bind(this);
    this.removePromoCode = this.removePromoCode.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.activate = this.activate.bind(this);
  }

  componentDidMount() {
    this.setState({
      status: STATUSES.VALIDATING
    });

    API.GetCurrentPromoCode().then(response => {
      const activePromoCode = response.result;
      if (activePromoCode) {
        this.setState({
          activated: true,
          status: STATUSES.SUCCESS,
          activePromoCode: activePromoCode
        });
        this.props.onPromoCodeReady(activePromoCode);
      } else {
        this.setState({
          status: STATUSES.NOT_ASKED
        });
      }
    });
  }

  addPromoCode(promoCode) {
    this.setState({
      status: STATUSES.PENDING
    });

    var data = new FormData();
    data.append('promocode', promoCode);

    return window
      .fetch(this.state.endpoints.add, {
        method: 'POST',
        credentials: 'same-origin',
        body: data
      })
      .then(checkRawStatus)
      .then(response => response.text())
      .then(
        response => {
          if (response === 'success') {
            this.setState({
              status: STATUSES.SUCCESS
            });

            window.location.reload();
          } else {
            this.setState({
              status: STATUSES.FAILURE
            });
          }
        },
        () => {
          this.setState({
            status: STATUSES.FAILURE
          });
        }
      );
  }

  activate(e) {
    e.preventDefault();
    this.setState({
      activated: true
    });
  }

  removePromoCode() {
    this.setState({
      status: STATUSES.REMOVING
    });

    return window
      .fetch(this.state.endpoints.remove, {
        method: 'POST',
        credentials: 'same-origin'
      })
      .then(checkRawStatus)
      .then(response => response.text())
      .then(
        response => {
          if (response === 'success') {
            this.setState({
              status: STATUSES.NOT_ASKED
            });

            window.location.reload();
          } else {
            this.setState({
              status: STATUSES.FAILURE
            });
          }
        },
        () => {
          this.setState({
            status: STATUSES.FAILURE
          });
        }
      );
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    let inputValue = this.state.value;

    if (this.state.activePromoCode) {
      this.removePromoCode();
    } else if (inputValue) {
      this.addPromoCode(inputValue);
    }
  }

  render() {
    const buttonLabel = (() => {
      const labels = {
        NOT_ASKED: 'Apply',
        PENDING: 'Applying',
        REMOVING: 'Removing',
        SUCCESS: 'Remove',
        FAILURE: 'Apply'
      };

      return labels[this.state.status] || labels[STATUSES.NOT_ASKED];
    })();

    return this.state.status === STATUSES.VALIDATING ? (
      <p className="promo-code-loading">
        Checking for existing promotional code...
      </p>
    ) : this.state.activated === true ? (
      <form className="promo-code-form" action="" onSubmit={this.handleSubmit}>
        <div className="promo-code-form__field">
          <div className="input-addon">
            <input
              className="input-addon__input"
              type="text"
              onChange={this.handleChange}
              placeholder="Promotional Code"
              value={this.state.activePromoCode || this.state.value}
              readOnly={this.state.activePromoCode}
              tabIndex={2}
            />
            <input
              className="input-addon__action syos-button"
              type="submit"
              disabled={this.state.status === STATUSES.PENDING}
              value={buttonLabel}
              tabIndex={2}
            />
          </div>
        </div>
        {this.state.status === STATUSES.FAILURE && (
          <p className="promo-code-form__message">
            The promotional code you entered is not valid
          </p>
        )}
      </form>
    ) : (
      <p>
        Have you got a{' '}
        <a
          href={'#'}
          className="promo-code-action"
          onClick={e => this.activate(e)}
          onKeyDown={e => {
            const code = e.charCode || e.keyCode || e.which;
            [13, 32].indexOf(code) !== -1 ? this.activate(e) : null;
          }}
          tabIndex={2}
        >
          promo code?
        </a>
      </p>
    );
  }
}

PromoCode.propTypes = {
  onPromoCodeReady: PropTypes.func.isRequired
};

export default PromoCode;



// WEBPACK FOOTER //
// ./src/javascripts/components/PromoCode.js